import { Search } from '@shared/components/ui/Search';
import { cn } from '@shared/utils/utils';
import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface AccountingSyncFiltersSectionProps {
  searchValue: string;
  onSearch: (value: string) => void;
  className?: string;
}

export const AccountingSyncFiltersSection = ({
  searchValue,
  onSearch,
  className,
}: AccountingSyncFiltersSectionProps) => {
  const { t } = useTranslation('accountingSyncModule');
  const [inputValue, setInputValue] = useState(searchValue);

  useEffect(() => {
    setInputValue((prev) => (prev === searchValue ? prev : searchValue));
  }, [searchValue]);

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  const handleSearchSubmit = useCallback(() => {
    onSearch(inputValue.trim());
  }, [inputValue, onSearch]);

  return (
    <div className={cn('flex flex-wrap items-center gap-3', className)}>
      <Search
        placeholder={t('search.placeholder')}
        value={inputValue}
        onChange={handleInputChange}
        onEnter={handleSearchSubmit}
        dataTestId="accounting-sync-search"
        inputDataTestId="accounting-sync-search-input"
      />
    </div>
  );
};
